import { useEffect, useState } from 'react';
import { usePrevious } from './usePrevious';
import { debounce } from '../domain/utils/debounce';
import { breakpointService } from '../domain/services/breakpointService';

export const useBreakpoint = ({ wait = 200 } = {}) => {
  const [breakpoint, setBreakpoint] = useState(() =>
    breakpointService.getCurrentBreakpoint()
  );
  const previousBreakpoint = usePrevious(breakpoint);
  const handleResizeRaw = () => {
    setBreakpoint(breakpointService.getCurrentBreakpoint());
  };
  const handleResize = wait ? debounce(handleResizeRaw, wait) : handleResizeRaw;

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return [breakpoint, previousBreakpoint];
};
